import React, {FC} from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const SvgIconPlayground: FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        <svg viewBox="0 0 48.627968 37.511547">
            <defs
                id="defs883147">
                <clipPath
                    clipPathUnits="userSpaceOnUse"
                    id="clipPath257564">
                    <path
                        d="M 0,792 H 612 V 0 H 0 Z"
                        id="path257562"/>
                </clipPath>
                <radialGradient
                    xlinkHref="#linearGradient864886"
                    id="radialGradient864898"
                    cx="268.68634"
                    cy="-696.43951"
                    fx="268.68634"
                    fy="-696.43951"
                    r="53.021774"
                    gradientTransform="matrix(0.32422635,-0.13903032,0.14999222,0.34979011,166.16963,347.23507)"
                    gradientUnits="userSpaceOnUse"
                    spreadMethod="pad"/>
                <linearGradient
                    id="linearGradient864886">
                    <stop
                        style={{stopColor: "#ff0000", stopOpacity: 1}}
                        offset="0"
                        id="stop864882"/>
                    <stop
                        style={{stopColor: "#b70000", stopOpacity: 1}}
                        offset="0.65709645"
                        id="stop864904"/>
                    <stop
                        style={{stopColor: "#9d0000", stopOpacity: 1}}
                        offset="0.9160254"
                        id="stop872266"/>
                    <stop
                        style={{stopColor: "#890000", stopOpacity: 1}}
                        offset="1"
                        id="stop864884"/>
                </linearGradient>
                <clipPath
                    clipPathUnits="userSpaceOnUse"
                    id="clipPath257766">
                    <path
                        d="M 0,792 H 612 V 0 H 0 Z"
                        id="path257764"/>
                </clipPath>
            </defs>
            <g
                id="layer1"
                transform="translate(-126.51998,-52.434298)">
                <g
                    id="g257558"
                    style={{display: "inline"}}
                    transform="matrix(0.35277777,0,0,-0.35277777,56.136929,311.96234)">
                    <g
                        id="g257560"
                        clipPath="url(#clipPath257564)">
                        <g
                            id="g257622"
                            transform="translate(329.4756,714.4771)">
                            <path
                                d="m 0,0 c -1.781,6.65 -32.301,4.252 -68.168,-5.359 -35.868,-9.61 -63.497,-22.792 -61.715,-29.444 1.782,-6.651 32.302,-4.252 68.168,5.36 C -25.847,-19.834 1.783,-6.65 0,0"
                                style={{fill: "#727273", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257624"/>
                        </g>
                    </g>
                </g>
                <ellipse
                    style={{
                        display: "inline",
                        mixBlendMode: "normal",
                        fill: "url(#radialGradient864898)",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none",
                        strokeWidth: 0.27305,
                        strokeDasharray: "none"
                    }}
                    id="path861359"
                    cx="150.81252"
                    cy="71.190071"
                    rx="18.704903"
                    ry="18.755774"/>
                <g
                    id="g257760"
                    style={{display: "inline"}}
                    transform="matrix(0.35277777,0,0,-0.35277777,56.136929,311.96234)">
                    <g
                        id="g257762"
                        clipPath="url(#clipPath257766)"
                        style={{display: "inline"}}>
                        <g
                            id="g257768"
                            transform="translate(336.8936,686.1743)"
                            style={{display: "inline"}}>
                            <path
                                d="M 0,0 -7.352,27.43 C -7.977,20.549 -34.774,8.064 -69.133,-1.141 c -35.866,-9.611 -66.386,-12.01 -68.168,-5.359 l 7.795,-29.092 c 1.781,-6.651 32.302,-4.252 68.168,5.36 C -25.471,-20.623 2.16,-7.439 0.379,-0.789 0.303,-0.51 0.174,-0.247 0,0"
                                style={{fill: "#ffffff", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257770"/>
                        </g>
                        <g
                            id="g257772"
                            transform="translate(240.3774,664.3013)"
                            style={{display: "inline"}}>
                            <path
                                d="m 0,0 0.756,-2.82 -2.136,-0.344 -0.698,2.607 -1.551,5.79 2.139,0.327 z m -9.024,8.742 1.676,-6.256 1.115,-4.157 1.112,-4.157 1.113,-4.155 0.554,-2.065 4.285,0.631 -1.091,4.076 2.138,0.333 1.089,-4.064 4.257,0.738 L 6.385,-7.199 5.27,-3.043 4.156,1.113 3.043,5.27 1.65,10.467 Z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257774"/>
                        </g>
                        <g
                            id="g257776"
                            transform="translate(266.4536,666.8208)">
                            <path
                                d="M 0,0 1.111,-4.146 -0.967,-4.701 -2.08,-0.545 -3.195,3.611 -4.308,7.767 -4.309,7.771 1.927,9.435 0.812,13.592 -9.631,11.005 -8.464,6.653 -7.352,2.497 -6.236,-1.66 -5.123,-5.815 -4.08,-9.709 6.381,-7.187 5.271,-3.043 5.268,-3.031 4.157,1.114 3.043,5.269 -1.113,4.156 Z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257778"/>
                        </g>
                        <g
                            id="g257780"
                            transform="translate(228.272,655.4478)">
                            <path
                                d="m 0,0 -1.403,5.237 -1.115,4.155 -1.918,7.377 -4.435,-0.289 2.197,-8.201 1.114,-4.155 1.115,-4.155 1.173,-4.387 c 0,0 2.95,0.258 5.449,0.448 1.936,0.148 5.399,0.632 5.399,0.632 L 6.478,0.759 Z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257782"/>
                        </g>
                        <g
                            id="g257784"
                            transform="translate(276.8169,669.6255)">
                            <path
                                d="M 0,0 -1.115,4.156 -2.23,8.32 -0.178,8.945 0.963,4.713 2.076,0.557 Z M 7.322,-2.394 6.232,1.67 5.119,5.826 4.006,9.983 2.869,14.285 -7.498,11.356 l 1.113,-4.157 1.113,-4.156 1.114,-4.156 1.115,-4.156 1.113,-4.157 4.157,1.113 -1.081,4.11 1.039,0.295 3.088,-3.494 4.067,1.216 -3.092,3.469 z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257786"/>
                        </g>
                        <g
                            id="g257788"
                            transform="translate(301.6079,685.1616)">
                            <path
                                d="m 0,0 1.115,-4.155 1.114,-4.157 0.713,-2.663 -2.022,-0.768 -0.771,2.874 -1.112,4.153 v 0.004 l -1.113,4.15 -1.465,5.467 -4.061,-1.474 1.37,-5.106 1.112,-4.152 0.001,-0.003 1.113,-4.153 1.113,-4.155 0.846,-3.159 c 0,0 4.29,1.566 5.713,2.107 1.103,0.42 4.395,1.732 4.395,1.732 L 7.499,-11.355 6.384,-7.198 5.269,-3.042 4.156,1.114 2.507,7.271 -1.518,5.667 Z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257790"/>
                        </g>
                        <g
                            id="g257792"
                            transform="translate(250.4927,676.4243)">
                            <path
                                d="m 0,0 1.24,-4.628 1.114,-4.157 1.005,-3.746 -2.111,-0.441 -0.416,1.557 -0.556,2.075 -0.001,0.004 -1.114,4.156 -1.27,4.744 -4.239,-0.812 1.354,-5.045 1.113,-4.156 10e-4,-0.005 0.556,-2.075 0.556,-2.08 0.907,-3.377 3.173,0.619 1.091,-4.07 4.22,0.878 -1.091,4.071 3.154,0.701 -1.062,3.96 v 0.002 L 6.51,-7.67 5.396,-3.514 4.209,0.918 Z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257794"/>
                        </g>
                        <g
                            id="g257796"
                            transform="translate(289.1431,681.811)">
                            <path
                                d="m 0,0 1.113,-4.156 1.114,-4.157 0.982,-3.662 -2.048,-0.672 -0.05,0.184 -0.963,3.594 -0.002,0.01 -0.706,2.632 -0.408,1.519 v 0.005 l -1.237,4.621 2.047,0.671 z m -7.413,2.724 1.177,-4.39 1.111,-4.151 0.002,-0.003 0.407,-1.52 0.706,-2.633 0.002,-0.009 0.963,-3.594 0.15,-0.559 v -0.005 l 1.041,-3.883 10.237,3.36 -0.887,3.308 L 7.495,-11.35 6.383,-7.199 5.27,-3.043 4.156,1.114 4.153,1.119 3.041,5.27 2.827,6.068 Z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257798"/>
                        </g>
                        <g
                            id="g257800"
                            transform="translate(327.6592,687.688)">
                            <path
                                d="m 0,0 0.57,-2.123 -1.904,-1.209 -0.742,2.775 -2.576,9.817 1.861,1.153 z m -1.978,15.704 c 0,0 -2.842,-1.899 -3.815,-2.489 -0.945,-0.57 -3.853,-2.15 -3.853,-2.15 l 1.115,-4.157 2.299,-8.579 1.113,-4.156 1.012,-3.774 c 0,0 3.693,1.984 5.675,3.343 1.741,1.195 3.791,2.889 3.791,2.889 L 4.156,1.113 0.904,13.254 Z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257802"/>
                        </g>
                        <g
                            id="g257804"
                            transform="translate(216.3286,659.0923)">
                            <path
                                d="M 0,0 -2.243,0.06 -2.954,2.711 -4.505,8.5 -2.245,8.377 -0.876,3.268 Z m -10.229,13.236 2.005,-7.482 1.115,-4.156 1.113,-4.158 1.113,-4.155 0.275,-1.021 c 0,0 1.6,-0.233 2.136,-0.285 0.608,-0.059 2.436,-0.157 2.436,-0.157 l -1.108,4.059 c 0,0 2.408,-0.066 3.23,-0.063 0.852,0.002 3.466,0.086 3.466,0.086 L 4.395,0.226 3.281,4.381 2.167,8.538 1.053,12.694 c 0,0 -3.133,-0.176 -5.559,-0.034 -2.487,0.149 -5.723,0.576 -5.723,0.576"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257806"/>
                        </g>
                        <g
                            id="g257808"
                            transform="translate(312.0869,695.8384)">
                            <path
                                d="m 0,0 1.383,-5.068 1.115,-4.157 1.113,-4.156 v -0.007 l 0.51,-1.897 -2.875,2.42 -0.828,3.084 -1.111,4.156 -1.254,4.744 -4.018,-1.702 1.114,-4.156 1.115,-4.157 1.113,-4.157 1.113,-4.156 0.002,-0.002 1.096,-4.096 3.996,1.718 -0.828,3.086 2.805,-2.157 3.949,1.892 -0.627,2.338 -0.606,2.258 -0.507,1.899 -0.004,0.005 -1.114,4.157 -1.113,4.156 -1.568,5.859 z"
                                style={{fill: "#231f20", fillOpacity: 1, fillRule: "nonzero", stroke: "none"}}
                                id="path257810"/>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </SvgIcon>
);

export default SvgIconPlayground
